import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetTelehealthDocsParams,
	GetTelehealthDocsResponse,
	GetTelehealthDocs,
} from 'domain/usecases';

export class RemoteGetTelehealthDocs implements GetTelehealthDocs {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetTelehealthDocsResponse>,
	) {}

	async get({signal, ...params}: GetTelehealthDocsParams): Promise<GetTelehealthDocsResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
